const knowledgeStructureData = {
  // 绘表数据
  chartData: {
    // 节点枚举
    nodes: [],
    // 线条枚举
    links: []
  },
  // 底部说明文字
  bottomText: ''
};
import { setSevenDay } from './utils'
let oneMonth = setSevenDay(30);
// 获取当前日期前7天
//设置日期，当前日期的前七天 
let myDate = new Date();
let myYear = myDate.getFullYear();
//获取今天日期 
myDate.setDate(myDate.getDate() - 7);
let dateArray = [];
let dateTemp;
let flag = 1;
for (let i = 0; i < 7; i++) {
  dateTemp = myYear + "/" + (myDate.getMonth() + 1) + "/" + myDate.getDate();
  dateArray.push(dateTemp);
  myDate.setDate(myDate.getDate() + flag);
}
const schoolPic = {
  // 应用概况
  overviewObject: {
    evaluationName: '测评',
    evaluationRate: '1534', // 测评人次
    interveneName: '干预',
    interveneRate: '178', // 测评人次
    earlyName: '预警',
    earlyRate: '236', // 测评人次
    totalNum: '1278'
  },
  applicationList: [{
    name: '使用频次',
    value: 1
  }, {
    name: '使用时长',
    value: 2
  }],
  applicationSatus: 1,
  // 应用趋势
  timesList: [{
    name: '近7天',
    value: 1
  }, {
    name: '近一个月',
    value: 2
  }, {
    name: '近三个月',
    value: 3
  }],
  // 应用趋势时间
  timesStatus: 1,
  // 使用频次
  // 近7天X轴
  // dataNameFirst: ['2022/09/07', '2022/09/08', '2022/09/09', '2022/09/10', '2022/09/11', '2022/09/12', '2022/09/13'],
  dataNameFirst: dateArray,
  // 近7天y轴
  lineDataFirst: [123, 234, 432, 143, 334, 232, 147],
  timesDataFirst: [256, 498, 464, 456, 398, 424, 332],
  // 近一个月x轴
  dataNameSecond: setSevenDay(30),
  // 近一个月y轴
  lineDataSecond: [220, 182, 191, 134, 150, 120, 110, 220, 182, 191, 134, 150, 120, 110, 220, 182, 191, 134, 150, 120, 110, 220, 182, 191, 134, 150, 120, 110, 220, 182],
  timesDataSecond: [120, 110, 125, 145, 122, 165, 122, 120, 110, 125, 145, 122, 165, 122, 120, 110, 125, 145, 122, 165, 122, 120, 110, 125, 145, 122, 165, 122, 120, 110],
  // 近三个月x轴
  dataNameThree: setSevenDay(90),
  // 近一个月y轴
  lineDataThree: [220, 182, 191, 134, 150, 120, 110, 220, 182, 191, 134, 150, 120, 110, 220, 182, 191, 134, 150, 120,
    110, 220, 182, 191, 134, 150, 120, 110, 220, 182, 220, 182, 191, 134, 150, 120, 110, 220, 182, 191, 134, 150, 120,
    110, 220, 182, 191, 134, 150, 120, 110, 220, 182, 191, 134, 150, 120, 110, 220, 182, 220, 182, 191, 134, 150, 120,
    110, 220, 182, 191, 134, 150, 120, 110, 220, 182, 191, 134, 150, 120, 110, 220, 182, 191, 134, 150, 120, 110, 220,
    182],
  timesDataThree: [120, 110, 125, 145, 122, 165, 122, 120, 110, 125, 145, 122, 165, 122, 120, 110, 125, 145, 122, 165,
    122, 120, 110, 125, 145, 122, 165, 122, 120, 110, 120, 110, 125, 145, 122, 165, 122, 120, 110, 125, 145, 122, 165,
    122, 120, 110, 125, 145, 122, 165, 122, 120, 110, 125, 145, 122, 165, 122, 120, 110, 120, 110, 125, 145, 122, 165,
    122, 120, 110, 125, 145, 122, 165, 122, 120, 110, 125, 145, 122, 165, 122, 120, 110, 125, 145, 122, 165, 122, 120,
    110],
  // 使用时长
  // 近七天
  useingDataFirst: ['3', '4', '2'],
  // 近一个月
  useingDataSecond: ['10.1', '12.6', '13.8'],
  // 近三个月
  useingDataThree: ['30.4', '43.2', '28'],
  // 校园覆盖概况模块
  coverObject: {
    // 预警参数
    warningLabel: '预警人数',
    warningTimes: '相比过去一个月',
    warningNum: '24', // 人数
    warningStatus: 0, // 0 下降 1 上升 箭头方向
    warningPercentage: '32%', // 人数占比
    // 社交焦虑参数
    anxiousLabel: '本校压力源',
    anxiousTimes: '最近一个月学校的压力',
    anxiousText: '社交焦虑',
    // 干预覆盖率
    InterventionLabel: '干预覆盖率',
    InterventionTimes: '最近一个月',
    InterventionNum: '50.2%', // 覆盖率
    InterventionStatus: 1, // 0 下降 1 上升
    InterventionPercentage: '37%', //占比
  },
  // 智能干预和压力监测
  intelligentPressureObj: {
    intelligentName: '智能干预',
    intelligentNum: '56',
    pressureName: '压力监测',
    pressureNum: '23'
  },

  // 心理素养
  accomplishmentStatus: '',
  // 分层关注
  layeredStatus: '',
  academicSection: [{
    name: '本校',
    value: ''
  }, {
    name: '高中',
    value: '3'
  }, {
    name: '初中',
    value: '2'
  }, {
    name: '小学',
    value: '1'
  }],
  tableHeader: [{
    name: '轻度'
  }, {
    name: '中度'
  }, {
    name: '重度'
  }, {
    name: '干预覆盖率'
  }],
  // 轻度 中度 重度 干预覆盖率
  tableBody: [{
    label: '适应不良',
    status: '优于平均水平', // waring 0 减号 1加号
    tips: '适应不良：指各种情绪上的干扰妨碍了个体从事有效的社会活动。',
    statusNum: '16.3%',
    light: '45.2%',
    lightStatus: 1, // 0 下降 1 上升
    moderate: '30%',
    moderateStatu: 0,
    severe: '24..8%',
    moderateStatu: 0,
    coverage: '78%',
    waring: 0,  // 1预警 0 不预警
  }, {
    label: '焦虑程度',
    status: '差于平均水平',
    tips: '焦虑程度：焦虑主要是指学生对周围事物或环境产生的一种广泛性的担忧与不安，这种担忧与不安可能并没有特定对象，而是一种普遍的、泛化的焦虑状态。',
    statusNum: '6.2%',
    light: '80%',
    lightStatus: 1, // 0 下降 1 上升
    moderate: '17.4%',
    moderateStatu: 0,
    severe: '2.6%',
    moderateStatu: 0,
    coverage: '89.4%',
    waring: 1
  }, {
    label: '抑郁程度',
    status: '差于平均水平',
    tips: '抑郁程度：抑郁主要指学生的一种忧郁苦闷的感情和心境，学生可能表现出情绪低落，意志力减退、对所有事情失去兴趣等情况，同时还伴有睡眠障碍及食欲减退等生理现象。',
    statusNum: '5.5%',
    light: '78.9%',
    lightStatus: 1, // 0 下降 1 上升
    moderate: '12.1%',
    moderateStatu: 0,
    severe: '10%',
    moderateStatu: 0,
    coverage: '70%',
    waring: 1
  }],
  // 分层关注
  layeredAttention: [{
    name: "良好",
    value: 78,
    leave: 1,
    rate: '11%'
  }, {
    name: "一级关注",
    value: 11,
    leave: 2,
    rate: '11%'
  }, {
    name: "二级关注",
    value: 8,
    leave: 3,
    rate: '11%'
  }, {
    name: "三级关注",
    value: 3,
    leave: 4,
    rate: '11%'
  }],
  activeLayerStatus: 2,
  classList: [{
    className: '高三（3）班',
    leave: 4,
    label: '情绪不稳定',
    tips: '开展情绪管理课程'
  }, {
    className: '高一（4）班',
    leave: 2,
    label: '社交焦虑',
    tips: '开展人际交往课程'
  }, {
    className: '高二（14）班',
    leave: 1,
    label: '社交焦虑',
    tips: '开展人际交往课程'
  },
  {
    className: '高三（1）班',
    leave: 3,
    label: '考试焦虑',
    tips: '设置考前辅导讲座'
  },
    // {
    //   className: '高二（7）班',
    //   leave: 3,
    //   label: '强迫',
    //   tips: '个体咨询'
    // }, {
    //   className: '高三（8）班',
    //   leave: 3,
    //   label: '抑郁',
    //   tips: '个体咨询'
    // }, {
    //   className: '高三（10）班',
    //   leave: 3,
    //   label: '考试焦虑',
    //   tips: '设置考前辅导讲座'
    // }, {
    //   className: '高三（11）班',
    //   leave: 3,
    //   label: '社交焦虑',
    //   tips: '开展人际交往课程'
    // }, {
    //   className: '高二（6）班',
    //   leave: 2,
    //   label: '情绪不稳定',
    //   tips: '开展情绪管理课程'
    // }, {
    //   className: '高一（7）班',
    //   leave: 2,
    //   label: '抑郁',
    //   tips: '个体咨询'
    //   }
  ]

}

const studentPicPreData = {
  personRelationship: [
    {
      title: '同伴交往',
      color: '#FF8A58',
      perc: 65
    },
    {
      title: '师生关系',
      color: '#45D797',
      perc: 60
    },
    {
      title: '亲子关系',
      color: '#FAFF89',
      perc: 64
    },
    {
      title: '沟通技巧',
      color: '#FAFF89',
      perc: 64
    }
  ]
}

const growthPortfolioData = {
  // 心理状态
  psychologicalStatus: {
    dataX: ['04-25', '04-26', '04-27', '04-28', '04-29', '04-30', '05-01', '05-02', '05-03', '05-04', '05-05', '05-06', '05-07', '05-08', '05-09', '05-10', '05-11', '05-12', '05-13', '05-14', '05-15', '05-16', '05-17', '05-18', '05-19', '05-20', '05-21', '05-22', '05-23', '05-24', '05-25'],
    dataY1: [80, 86, 84, 75, 72, 70, 78, 58, 44, 41, 40, 60, 66, 75, 76, 77, 75, 72, 93, 93, 94, 92, 92, 91, 89, 89, 88, 87, 86, 85, 84, 83, 82, 78, 76, 74],
    dataY2: [80, 81, 80, 80, 80, 80, 82, 82, 81, 81, 80, 80, 82, 82, 81, 81, 80, 60, 62, 62, 64, 63, 63, 66, 66, 66, 66, 67, 68, 66, 69, 74, 72, 73, 71, 72],
    dataf: [70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70]
  },
  // 学会学习雷达图
  learnStudy: {
    indicator: [
      { text: '学会学习 ', max: 100 },    //这里用于设置各轴的参数以及最大值
      { text: '自我认识 ', max: 100 },
      { text: '情绪发展 ', max: 100 },
      { text: '社会与适应', max: 100 },
      { text: '升学择业', max: 100 },
      { text: '人际交往', max: 100 },
    ],
    studyData: [
      {
        value: [83, 30, 79, 65, 79, 42],
        name: 'A同学 '
      },
    ]
  },
  // 心理科普知识推荐数据
  popularnowledgelist: [
    {
      videoSrc: 'https://bj.download.cycore.cn/CSB-decompression-planet-service/fe99d4d3-239d-49b9-9aed-e5dcf8acaa6f/【视频】.考试焦虑的表现和成因-初高中版.mp4',
      mainText: '价值观与生涯发展的关系',
      subText: '了解自己的职业价值观对职业生涯发展的选择有重要影响',
      img: 'https://bj.download.cycore.cn/CSB-decompression-planet-service/146b5574-ea00-4d23-91ae-8308c273ca65/recommendment-bg1.png'
    }, {
      videoSrc: 'https://bj.download.cycore.cn/CSB-decompression-planet-service/fe99d4d3-239d-49b9-9aed-e5dcf8acaa6f/【视频】.考试焦虑的表现和成因-初高中版.mp4',
      mainText: '学习成绩的影响因素',
      subText: '探索影响学习成绩的因素，及时调整学习策略',
      img: 'https://bj.download.cycore.cn/CSB-decompression-planet-service/008ae0a0-c943-4c7a-8f65-4c55964f3cb4/recommendment-bg2.png'
    }, {
      videoSrc: 'https://bj.download.cycore.cn/CSB-decompression-planet-service/fe99d4d3-239d-49b9-9aed-e5dcf8acaa6f/【视频】.考试焦虑的表现和成因-初高中版.mp4',
      mainText: '考试焦虑的表现和成因',
      subText: '认识考试焦虑，识别并有效应对考试焦虑',
      img: 'https://bj.download.cycore.cn/CSB-decompression-planet-service/cdba3540-3f7a-4b1c-afa0-16d6c520125c/recommendment-bg3.png'
    }, {
      videoSrc: 'https://bj.download.cycore.cn/CSB-decompression-planet-service/fe99d4d3-239d-49b9-9aed-e5dcf8acaa6f/【视频】.考试焦虑的表现和成因-初高中版.mp4',
      mainText: '理性情绪行为疗法',
      subText: '认识情绪，通过改变认知来调节不良情绪和行为',
      img: 'https://bj.download.cycore.cn/CSB-decompression-planet-service/0a2dd509-87ad-41d3-8b55-9d194f3d8b7a/recommendment-bg4.png'
    }, {
      videoSrc: 'https://bj.download.cycore.cn/CSB-decompression-planet-service/fe99d4d3-239d-49b9-9aed-e5dcf8acaa6f/【视频】.考试焦虑的表现和成因-初高中版.mp4',
      mainText: '心理适应能力',
      subText: '良好的心理适应能力帮助个体顺利适应学校环境',
      img: 'https://bj.download.cycore.cn/CSB-decompression-planet-service/72374775-d2ed-4db8-9363-04e003a158e6/recommendment-bg5.png'
    },
  ],
  // 压力源与压力程度数据
  pressData: {
    data: [[320, 290, 320, 290], [120, 320, 290, 320], [220, 320, 290, 450], [150, 220, 320, 290]],
    legend: ['华为', '中兴', '烽火', '瑞斯'],
    colors: ['#4C98FB', '#83CCE7', '#26C7C8', '#73DEBD']
  }
}
export {
  knowledgeStructureData,
  schoolPic,
  studentPicPreData,
  growthPortfolioData

}


